import { SeasonStore } from '@yarmill/types';
import { useSeasonsStore } from './use-seasons-store';

export function useSeasonByYear(seasonYear: number): SeasonStore | undefined {
  return useSeasonsStore().getSeasonByYear(seasonYear);
}
